import { SessionInferenceMode } from "@/components/graphql/schema.graphql";
import { SessionInferenceModeType } from "@/types";

export const INFERENCE_MODE_TO_MODE_TYPE: Record<
  SessionInferenceMode,
  SessionInferenceModeType
> = {
  REALTIME: "realtime",
  CREATE: "create",
  CREATE_3_D: "create3D",
  CREATE_VIDEO: "createVideo",
  CREATE_SPEECH: "createSpeech",
  CREATE_SOUND_EFFECT: "createSoundEffect",
  PROMPT_EDIT_IMAGE: "promptEditImage",
  PROMPT_EDIT_VIDEO: "promptEditVideo",
  BLUEPRINT: "blueprint",

  // Refine image modes
  UPSCALE: "upscale",
  REFRAME_IMAGE: "reframeImage",
  VECTORIZE_IMAGE: "vectorizeImage",
  REMOVE_BACKGROUND: "removeBackground",
  SPLIT_IMAGE_INTO_LAYERS: "splitImageIntoLayers",

  // Refine video modes
  UPSCALE_VIDEO: "upscaleVideo",
  REFRAME_VIDEO: "reframeVideo",
  ADD_SFX_VIDEO: "addSfxVideo",
  REMOVE_BACKGROUND_VIDEO: "removeBackgroundVideo",

  // Refine 3D modes
  ANIMATE_MESH: "animateMesh",
  RETEXTURE_MESH: "retextureMesh",
  RIG_MESH: "rigMesh",
  REMESH: "remesh",
  SEGMENT_MESH: "segmentMesh",

  // Canvas modes
  CANVAS_2_D: "canvas2D",
  CANVAS_PROMPT_EDIT: "canvasPromptEdit",
};

export const MODE_TYPE_TO_INFERENCE_MODE = Object.fromEntries(
  Object.entries(INFERENCE_MODE_TO_MODE_TYPE).map(([k, v]) => [v, k]),
) as Record<SessionInferenceModeType, SessionInferenceMode>;
